export default function error(state = {}) {
    return state;
}
